import "./BackgroundWrapper.css";

function BackgroundWrapper({ children }) {
    return <div className={"background"}>{children}</div>;
}

export default BackgroundWrapper;
